'clerk'

import { useOrganization } from '@clerk/clerk-react'

export const useWorkspace = () => {
  const { organization } = useOrganization()
  return organization?.slug
}
